import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsultarDenunciaComponent } from 'src/app/ver-denuncias/components/consultar-denuncia/consultar-denuncia.component';
import { VerDenunciaComponent } from 'src/app/ver-denuncias/components/ver-denuncia/ver-denuncia.component';
import { AuthGuardComplaint } from './guards/authComplaint.guard';

const routes: Routes = [
  {
    path: 'consultar-denuncia',
    component: ConsultarDenunciaComponent
  },
  {
    path: ':id',
    canActivate: [AuthGuardComplaint],
    component: VerDenunciaComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DenunciasRoutingModule { }
